import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import VideoOverlay from '../components/VideoOverlay';

const IntroPage: React.FC = () => {
  const [showVideo, setShowVideo] = useState(true);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has seen the intro before (optional)
    const hasSeenIntro = localStorage.getItem('hasSeenIntro');
    
    // For development/testing, you can uncomment the line below to skip video
    // setShowVideo(false);
    
    if (hasSeenIntro === 'true') {
      // Uncomment if you want to skip video for returning users
      // setShowVideo(false);
      // navigate('/login');
    }
  }, [navigate]);

  const handleVideoComplete = () => {
    setIsTransitioning(true);
    
    // Mark that user has seen the intro
    localStorage.setItem('hasSeenIntro', 'true');
    
    // Smooth transition to login page
    setTimeout(() => {
      navigate('/login', { replace: true });
    }, 800);
  };

  if (!showVideo && !isTransitioning) {
    // If no video, go directly to login
    setTimeout(() => navigate('/login', { replace: true }), 100);
    return (
      <div className="w-full h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block w-16 h-16 border-4 border-purple-500/20 border-t-purple-500 rounded-full mb-4 animate-spin" />
          <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">
            Loading Looplet AI...
          </h1>
        </div>
      </div>
    );
  }

  return (
    <div className="relative w-full h-screen bg-black">
      {/* Video Overlay */}
      {showVideo && (
        <VideoOverlay 
          onComplete={handleVideoComplete}
          skipVideo={!showVideo}
        />
      )}

      {/* Transition Background (appears during video transition) */}
      {isTransitioning && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900"
        >
          {/* Optional: Add a loading spinner or logo during transition */}
          <div className="absolute inset-0 flex items-center justify-center">
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="text-center"
            >
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                className="inline-block w-16 h-16 border-4 border-purple-500/20 border-t-purple-500 rounded-full mb-4"
              />
              <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">
                Welcome to Looplet AI
              </h1>
            </motion.div>
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default IntroPage;